import styled from 'styled-components';
import { colors, MediaQuery } from '../../theme/style-helpers';
import { H1, P } from '../../theme/typographySitecore';
import Row from '../ReactComponent/Row';
import PrimaryButton from '../ReactComponent/PrimaryButton';
import Column from '../ReactComponent/Column';

export const HeaderContainer = styled(Row)`
  margin-bottom: 32px;
`;

export const HeaderTitle = styled(H1)`
  margin-bottom: 3rem;
`;

export const FieldContainer = styled(Column)`
  flex-basis: unset !important;
`;

export const ReferenceNumberContainer = styled(Row)`
  padding: 8px 0;
  margin: -8px 0;
  background-color: ${colors.LIGHT_GREY};
`;

export const ReferenceNumberSummary = styled(P)`
  padding-top: 24px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 72px;
    gap: 32px;
    flex-wrap: wrap;
`;

export const ResetButton = styled(PrimaryButton)`
  margin-bottom: 16px;
  
  ${MediaQuery.medium`
    margin-bottom: 0;
    margin-right: 16px;    
  `} 
`;

export const FeedbackForm = styled.div`
  display: grid;
  grid-gap: 32px;

  .row {
    row-gap: 32px;
  }
`;

export const FieldLabel = styled.span`
  display: inline-block;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 8px;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0em;
  margin: 0 0 16px 0;

  ${MediaQuery.small`
    font-size: 3.6rem;
    font-weight: 500;
    line-height: 47px;
  `}
`;

export const SubTitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;

  ${MediaQuery.small`
    font-size: 16px;
    line-height: 24px;
  `}
`;
